import MailIcon from "@mui/icons-material/Mail";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import { FaRegFilePdf } from "react-icons/fa";
import { GoBook } from "react-icons/go";
import SmsIcon2 from "@mui/icons-material/Sms";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import { LuFileJson2 } from "react-icons/lu";
import WebIcon from "@mui/icons-material/Web";
import PublicIcon from "@mui/icons-material/Public";

export function PdfIcon(props) {
  return <FaRegFilePdf color="primary" {...props} />;
}

export function BookIcon(props) {
  return <GoBook color="primary" {...props} />;
}

export function SmsIcon(props) {
  return <SmsIcon2 color="primary" {...props} />;
}

export function PhoneIcon(props) {
  return <PhoneEnabledIcon color="primary" {...props} />;
}

export function EmailIcon(props) {
  return <MailIcon color="primary" {...props} />;
}
export function EmailAtIcon(props) {
  return <AlternateEmailIcon {...props} />;
}

export function MessageIcon(props) {
  return <MailIcon color="primary" {...props} />;
}

export function JsonIcon(props) {
  return <LuFileJson2 color="primary" {...props} />;
}

export function BrowserIcon(props) {
  return <WebIcon color="primary" {...props} />;
}

export function GlobalIcon(props) {
  return <PublicIcon {...props} />;
}
